import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CustomWrapperComponent } from "../components/custom-wrapper-component/custom-wrapper-component";
import { SnackData } from "../model/snack-notification-model";

@Injectable({
  providedIn: "root"
})
export class NotificationService {
  private snackBar = inject(MatSnackBar);

  showSuccess(message: string): void {
    this.open({ message, icon: "faCircleCheck", type: "success" });
  }

  showError(message: string): void {
    this.open({ message, icon: "faExclamation", type: "error" });
  }

  private open(data: SnackData): void {
    this.snackBar.openFromComponent(CustomWrapperComponent, {
      data,
      duration: 3000,
      horizontalPosition: "end",
      verticalPosition: "top",
      panelClass: [`${data.type}-snackbar`]
    });
  }
}
